import axiosClient from "../axios/axiosClient";

export function getFacilities() {
  return axiosClient.get("/facilities");
}

export function getFacility(facilityId) {
  return axiosClient.get(`/facilities/${facilityId}`);
}

export function createFacility(data) {
  return axiosClient.post("/facilities", data);
}

export const updateFacility = (facilityId, data) => {
  return axiosClient.put(`/facilities/${facilityId}`, data);
};

export function deleteFacility(facilityId) {
  return axiosClient.delete(`/facilities/${facilityId}`);
}
